module.exports = __webpack_public_path__ + "img/区域直采.8771fbe8.png";